import IconThreeGradient, {
	IconThreeGradientProps as _IconThreeGradientProps,
} from './IconThreeGradient';

export { IconThreeGradient };
export type IconThreeGradientProps = _IconThreeGradientProps;
